const carousels = async function () {
    const tilesCarousel = [...document.querySelectorAll(".tiles-carousel")];


    if (tilesCarousel) {
        const Swiper = await (await import("swiper/bundle")).default;

        if (tilesCarousel) {
            tilesCarousel.forEach(section => {
                const carousel = new Swiper(section.querySelector(".swiper"), {
                    slidesPerView: 1.3,
                    lazy: true,
                    loop: true,
                    spaceBetween: 20,
                    speed: 650,
                    autoplay: {
                        delay: 5000,
                        disableOnInteraction: false,
                    },
                    breakpoints: {
                        // when window width is >= 320px
                        640: {
                            slidesPerView: 2.2,
                        },
                        900: {
                            slidesPerView: 2.8,
                        }
                    },
                })
            })
        }
    }
}

export const init = carousels;